'use client'

import { useState, useEffect } from 'react'
import { getDictionary } from './getDictionary'

/**
 * Hook do ładowania polskich słowników w komponentach klienckich
 * Zawsze zwraca polskie tłumaczenia z /locales/pl/
 */
export function useDict(dictName: string) {
  const [dict, setDict] = useState<any>(null)

  useEffect(() => {
    const loadDict = async () => {
      try {
        const dictData = await getDictionary(dictName)
        setDict(dictData)
      } catch (error) {
        console.error(`Error loading dictionary ${dictName}:`, error)
      }
    }

    loadDict()
  }, [dictName])

  return dict
}
